import { motion } from "framer-motion";

const AboutStatements = () => {
    const cardHover = {
    hover: {
      scale: 1.05,
      y: -8,
      boxShadow: "0px 15px 35px rgba(0,0,0,0.12)",
      transition: { duration: 0.3 },
    },
  };
    return (
         <section className="w-full bg-white py-20 font-['Epilogue'] overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
          className="max-w-6xl mx-auto px-6 text-center"
        >
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="text-center text-[28px] sm:text-[32px] lg:text-[36px] font-bold text-gray-900 mb-12"
          >
            JIVI’s Vision and Mission Statements
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          
            <motion.div
              variants={cardHover}
              whileHover="hover"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="p-8 border-2 border-dotted rounded-3xl border-blue-500 text-left bg-white"
            >
              <h3 className="text-2xl font-semibold mb-4">Mission</h3>
              <p className="text-[16px] font-normal text-gray-700 leading-relaxed text-start">
                To empower organizations through intelligent, cloud-based workforce
                solutions driven by innovation, integrity, and strong human values.
                We are committed to building meaningful partnerships by fostering
                transparency, collaboration, and exceptional communication. At
                JIVI Solutions, we strive to create technology that enhances human
                potential, strengthens relationships, and transforms workforce
                operations for sustainable growth.
              </p>
            </motion.div>

            <motion.div
              variants={cardHover}
              whileHover="hover"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="p-8 border-2 border-dotted rounded-3xl border-blue-500 text-left bg-white"
            >
              <h3 className="text-2xl font-semibold mb-4">Vision</h3>
              <p className="text-[16px] font-normal text-gray-700 leading-relaxed text-start">
                To be a global leader in workforce management technology, shaping
                the future of digital transformation across mission-critical
                industries. We envision a world where organizations achieve
                operational excellence through continuous innovation, teamwork, and
                a relentless pursuit of new capabilities—unlocking new opportunities
                and delivering value to businesses and communities worldwide.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </section>
    );
};

export default AboutStatements;